import React, { Component } from 'react';

export default class Selector extends Component {
    onChange(event) {
        if (this.props.handleChange) {
            this.props.handleChange(event);
        }
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.value !== this.props.value;
    }

    getValue() {
        return this.props.value;
    }

    renderLabel() {
        if (!this.props.label) {
            return '';
        }

        if (this.props.labelMobileOnly) {
            return (
                <div className="app__selector__label--mobile">
                    { this.props.label }
                </div>
            );
        }

        return <div className="app__selector__label">
            { this.props.label }
        </div>;
    }

    selectOption(event) {
        const newEvent = {
            target: {
                name: this.props.name,
                value: event.target.getAttribute('value'),
            },
        };

        this.onChange(newEvent);
    }

    renderOptions() {
        const optionsElements = [];

        for (let i = 0; i < this.props.optionsList.length; i++) {
            const option = this.props.optionsList[i];
            const selected = option.value === this.props.value;

            const selectedClass = selected ? 'app__selector__option--selected' : '';
            optionsElements.push(
                <div className={ `app__selector__option ${selectedClass}` }
                     name={ this.props.name }
                     onClick={ this.selectOption.bind(this) }
                     value={ option.value }>
                    { option.text }
                </div>
            );
        }

        return optionsElements;
    }

    render() {
        const widthProportion = this.props.widthProportion ? this.props.widthProportion : 'full';

        let style = {};
        if (this.props.fixedWidth) {
            style = {
                width: this.props.fixedWidth,
            };
        }

        return <div className="app__selector">
            { this.renderLabel() }
            <div className={ `app__selector__set ${widthProportion}` }
                 onChange={ this.onChange.bind(this) } style={ style }>
                { this.renderOptions() }
            </div>
        </div>;
    }
}

Selector.propTypes = {
    label: React.PropTypes.string,
    labelMobileOnly: React.PropTypes.bool,
    value: React.PropTypes.node,

    name: React.PropTypes.string,
    handleChange: React.PropTypes.func,
    widthProportion: React.PropTypes.string,
    fixedWidth: React.PropTypes.string,

    optionsList: React.PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/elements/Selector.jsx